import type { IPageResponse, IResponse, Loose, RequestConfig } from '~/api/interface';
import { fetch } from '~/api/request';
import type { IGuidVideo, ISeriesClass } from '../interface/class';

export function reqGuidVideos(params: any, config?: RequestConfig) {
  return fetch<IPageResponse<IGuidVideo>>('/help_center/guide_video/', {
    method: 'GET',
    params,
    ...config,
  });
}

// 获取当前视频的系列视频
export function fetchGuidVideoSeries(video_id: number, config?: RequestConfig) {
  return fetch<IResponse<IGuidVideo[]>>('/help_center/guide_video/get_same_class_videos/', {
    method: 'GET',
    params: {
      video_id,
    },
    ...config,
  });
}

export function getClassSeries(params: Loose, config?: RequestConfig) {
  return fetch<IPageResponse<ISeriesClass>>('/help_center/guide_video_class/', {
    method: 'GET',
    params,
    ...config,
  });
}
